import React from 'react';
import { Link } from 'react-router-dom';
import {
  errorPageBg,
  errorCodeClass,
  errorMessageClass,
  errorSubMessageClass,
} from '../../components/auth/authViewTheme';

const NotFound = () => (
  <div className={errorPageBg}>
    <p className={errorCodeClass} aria-hidden>
      404
    </p>
    <h1 className={errorMessageClass}>Page not found</h1>
    <p className={errorSubMessageClass}>
      The page you&apos;re looking for doesn&apos;t exist or has been moved.
    </p>
    <Link to="/" className="btn-secondary-mdl mt-8">
      Go to dashboard
    </Link>
  </div>
);

export default NotFound;
